<template>
    <div>
        <el-input
            v-if="limit == 1"
            :placeholder="placeholder"
            :disabled="disabled"
            :size="size"
            :readonly="isReadonly"
            style="line-hight: 40px"
            @blur="changeVal"
            v-model="name"
            class="input-with-select"
            width="60%"
        >
            <el-button slot="append" :disabled="disabled" @click="showSelectDialog" icon="el-icon-search"></el-button>
        </el-input>
        <el-input
            v-if="limit > 1 && isClick"
            type="textarea"
            :placeholder="placeholder"
            :size="size"
            :readonly="isReadonly"
            :rows="rowCount"
            @blur="changeVal"
            v-model="name"
            class="input-with-select"
            style="width: 100%;"
        >
        </el-input>
        <el-input
                v-if="limit > 1 && !btn && !isClick"
                type="textarea"
                :placeholder="placeholder"
                :disabled="disabled"
                :size="size"
                :readonly="isReadonly"
                :rows="rowCount"
                @focus="showSelectDialog"
                @blur="changeVal"
                v-model="name"
                class="input-with-select"
                style="width: 100%;"
            >
            </el-input>
        <button v-if="btn && !isClick" type="button" @click="showSelectDialog" class="el-button btn el-button--primary"><span>添加试题</span></button>
        <el-dialog :title="title" :close-on-click-modal="false" :append-to-body="true" :visible.sync="visible" width="80%">
            <el-row :gutter="15">
                <el-col :span="limit == 1 ? 24 : 18">
                    <el-form style="padding: 0; margin: 0;" :inline="true" ref="searchForm" class="query-form" @keyup.enter.native="refreshList()" @submit.native.prevent>
                        <el-form-item v-for="(search, index) in searchs" :key="index" :prop="search.prop">
                            <el-input size="small" v-model="searchForms[index]" :placeholder="search.label" clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="searchParams()" size="small">查询</el-button>
                            <el-button @click="resetSearch()" size="small">重置</el-button>
                        </el-form-item>
                    </el-form>
                    <el-table
                        :data="dataList"
                        v-loading="loading"
                        border
                        size="small"
                        ref="userTable"
                        @selection-change="selectionChangeHandle"
                        @sort-change="sortChangeHandle"
                        style="width: 100%"
                    >
                        <el-table-column v-if="limit != 1" type="selection" header-align="center" align="center" width="50"></el-table-column>
                        <template v-for="(column, index) in columns">
                            <el-table-column
                                v-if="column.img === 'img'"
                                :key="index"
                                :prop="column.prop"
                                header-align="center"
                                align="center"
                                min-width="100px"
                                :label="column.label"
                            >
                                <template scope='scope'>
                                    <img v-if='scope.row[column.prop]' :src='scope.row[column.prop]' style='width: 80px;height: 80px;margin: auto;'>
                                    <span v-else>--</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                v-else
                                :key="index"
                                :prop="column.prop"
                                header-align="center"
                                align="center"
                                min-width="100px"
                                :label="column.label"
                            >
                            <!-- 修改部分 -->
                                <template slot-scope="scope">
                                    <div v-if="column.children == undefined">{{ scope.row[column.prop] }}</div>
                                    <div v-else>
                                        <div style="text-align:left" v-for="(item,key) in column.children">{{ item.label }}: {{ scope.row[item.prop] }}</div>
                                    </div>
                                </template>
                            <!-- 修改结束部分 -->
                            </el-table-column>
                        </template>
                        <el-table-column
                            v-if="limit== 1"
                            align="center"
                            fixed="right"
                            label="操作"
                            width="200">
                            <template slot-scope="scope">
                                <el-button @click="selectionChangeHandleSingle(scope.row)" type="text" size="small">选择</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        @size-change="sizeChangeHandle"
                        @current-change="currentChangeHandle"
                        :current-page="pageNo"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageSize"
                        :total="total"
                        layout="total, sizes, prev, pager, next, jumper"
                    ></el-pagination>
                </el-col>
                <el-col :span="6" v-show="limit != 1">
                    <el-tag :key="tag.id" v-for="tag in dataListAllSelections" closable :disable-transitions="false" @close="del(tag)">{{
                        tag[labelName]
                    }}</el-tag>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible = false">关闭</el-button>
                <el-button type="primary" v-if="limit != 1" @click="doSubmit()">确定</el-button>
            </span>
            <!-- <ConsultRecord :queryForm="queryForm" :checkState="checkState" @resetCheckState="resetCheckState"></ConsultRecord> -->
        </el-dialog>
    </div>
</template>

<script>
import { get } from '@/utils/request.js';
import eventBus from '@/api/eventBus';

import { getUserById } from '@/api/user.js';
//import DictTypeListTable from '@/components/system/DictTypeListTable.vue';
export default {
    data() {
        return {
            searchForms: [],
            filterText: '',
            dataListAllSelections: [], // 所有选中的数据包含跨页数据
            dataListSelections: [],
            dataListSelections1:{},
            idKey: 'id', // 标识列表数据中每一行的唯一键的名称(需要按自己的数据改一下)
            dataList: [],
            dynamicTags: [],
            selectData: [],
            pageNo: 1,
            pageSize: 10,
            total: 0,
            loading: false,
            visible: false,
            name: '',
            relatedFee: '',
            enname: ''
        };
    },
    props: {
        limit: {
            type: Number,
            default: 1
        },
        isClick: {
            type: Boolean,
            default: false
        },
        rowCount: {
            type: Number,
            default: 5
        },
        columns: {
            type: Array,
            default: () => {
                return [];
            }
        },
        disabled: {
            type: Boolean,
            default: false
        },
        btn:{
            type: Boolean,
            default: false
        },
        searchs: {
            type: Array,
            default: () => {
                return [];
            }
        },
        dataListUrl: {
            type: String,
            default: () => {
                return null;
            }
        },
        queryEntityUrl: {
            type: String,
            default: () => {
                return null;
            }
        },
        entityBeanName: {
            type: String,
            default: () => {
                return null;
            }
        },
        value: {
            default: () => {
                return '';
            }
        },
        title: {
            type: String,
            default: () => {
                return '';
            }
        },
        labelName: {
            type: String,
            default: () => {
                return '';
            }
        },
        labelValue: {
            type: String,
            default: () => {
                return '';
            }
        },
        size: {
            type: String,
            default: () => {
                return 'default';
            }
        },
        goodsCategoryName: {
            type: String,
            default: () => {
                return '';
            }
        },
        isReadonly: {
            type: Boolean,
            default: true
        },
        ParentComponentName: {
            type: String,
            default: () => {
                return '';
            }
        },
        userName: {
            type: String,
            default: () => {
                return '';
            }
        },
        placeholder: {
            type: String,
            default: '请选择'
        },
        token: {
            type: String,
            default: localStorage.getItem('token')
        },
        resetInput:{
            type: Boolean,
            default: false
        }
    },
    watch: {
        value: {
            handler(newVal) {
                this.selectData = [];
                newVal = newVal + ''
                if (newVal) {
                    newVal.split(',').forEach((value) => {
                        if (value) {
                            get(this.queryEntityUrl, { id: value }).then((data) => {
                                if (data[this.entityBeanName][this.labelValue] !== '') {
                                    this.selectData.push(data[this.entityBeanName]);
                                }
                            });
                            // getUserById({id: value}).then(())
                        }
                    });
                }
            },
            immediate: true,
            deep: false
        },
        userName: {
            handler(newVal) {
                this.name = '';
                // if (newVal) {
                //     this.name = newVal;
                // }
            }
        },
        selectData: {
            handler(newVal) {
                this.dataListAllSelections = JSON.parse(JSON.stringify(this.selectData));
                this.name = this.dataListAllSelections
                    .map((item) => {
                        return item[this.labelName];
                    })
                    .join(',');
            },
            immediate: false,
            deep: false
        },
        //重置
        resetInput:{
            handler(){
                this.name = ''
            },
            immediate: false,
            deep: false
        }
    },
    created() {
        eventBus.$on('empty', (data) => {
            console.log(131312131);
            // 不改变原组件的值
            this.name = '';
        });
    },
    methods: {
        init() {
            this.visible = true;
            this.$nextTick(() => {
                this.resetSearch();
            });
        },
        // 设置选中的方法
        setSelectRow() {
            if (!this.dataListAllSelections || this.dataListAllSelections.length <= 0) {
                this.$refs.userTable.clearSelection();
                return;
            }
            // 标识当前行的唯一键的名称
            let idKey = this.idKey;
            let selectAllIds = [];
            this.dataListAllSelections.forEach((row) => {
                selectAllIds.push(row[idKey]);
            });
            this.$refs.userTable.clearSelection();
            for (var i = 0; i < this.dataList.length; i++) {
                if (selectAllIds.indexOf(this.dataList[i][idKey]) >= 0) {
                    // 设置选中，记住table组件需要使用ref="table"
                    this.$refs.userTable.toggleRowSelection(this.dataList[i], true);
                }
            }
        },
        // 记忆选择核心方法
        changePageCoreRecordData() {
            // 标识当前行的唯一键的名称
            let idKey = this.idKey;
            let that = this;
            // 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
            if (this.dataListAllSelections.length <= 0) {
                this.dataListSelections.forEach((row) => {
                    that.dataListAllSelections.push(row);
                });
                console.log(this.dataListAllSelections)
                return;
            }
            // 总选择里面的key集合
            let selectAllIds = [];
            this.dataListAllSelections.forEach((row) => {
                selectAllIds.push(row[idKey]);
            });
            let selectIds = [];
            // 获取当前页选中的id
            this.dataListSelections.forEach((row) => {
                selectIds.push(row[idKey]);
                // 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里
                if (selectAllIds.indexOf(row[idKey]) < 0) {
                    that.dataListAllSelections.push(row);
                }
            });
            let noSelectIds = [];
            // 得到当前页没有选中的id
            this.dataList.forEach((row) => {
                if (selectIds.indexOf(row[idKey]) < 0) {
                    noSelectIds.push(row[idKey]);
                }
            });
            noSelectIds.forEach((id) => {
                if (selectAllIds.indexOf(id) >= 0) {
                    for (let i = 0; i < that.dataListAllSelections.length; i++) {
                        if (that.dataListAllSelections[i][idKey] === id) {
                            // 如果总选择中有未被选中的，那么就删除这条
                            that.dataListAllSelections.splice(i, 1);
                            break;
                        }
                    }
                }
            });
        },
        // 得到选中的所有数据
        getAllSelectionData() {
            // 再执行一次记忆勾选数据匹配，目的是为了在当前页操作勾选后直接获取选中数据
            this.changePageCoreRecordData();
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
        },
        del(tag) {
            this.dataListAllSelections.splice(this.dataListAllSelections.indexOf(tag), 1);
            this.$nextTick(() => {
                this.setSelectRow();
            });
        },
        searchParams(){
            this.pageNo = 1;
            this.refreshList()
        },
        // 获取数据列表
        refreshList() {
            this.loading = true;
            let searchForm = {};
            this.searchs.forEach((search, index) => {
                searchForm[search.prop] = this.searchForms[index];
            });
            console.log(this.searchs,this.searchForms)
            get(this.dataListUrl, { ...searchForm, pageNum: this.pageNo, pageSize: this.pageSize }).then((res) => {
                if (res.success) {
                    this.dataList = res.page.list;
                    this.total = res.page.total;
                    this.loading = false;
                }
            });
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageNo = 1;
            this.refreshList();
            this.$nextTick(() => {
                this.changePageCoreRecordData();
            });
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageNo = val;
            this.refreshList();
            this.$nextTick(() => {
                this.changePageCoreRecordData();
            });
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
            console.log(val);
            this.$nextTick(() => {
                this.changePageCoreRecordData();
            });
        },
        // 单选
        selectionChangeHandleSingle(val) {
            this.dataListSelections1 = val;
            console.log(val);
            this.$nextTick(() => {
                this.changePageCoreRecordData();
            });
            this.doSubmit('1')
        },
        // 排序
        sortChangeHandle(obj) {
            if (obj.order === 'ascending') {
                this.orderBy = obj.prop + ' asc';
            } else if (obj.order === 'descending') {
                this.orderBy = obj.prop + ' desc';
            } else {
                this.orderBy = '';
            }
            this.refreshList();
        },
        resetSearch() {
            this.$refs.searchForm.resetFields();
            this.searchForms = [];
            this.pageNo = 1;
            this.refreshList();
        },
        doSubmit(val='') {
            if(val ==  '1'){
                this.name = this.dataListSelections1[this.labelName]
                value = this.dataListSelections1[this.labelValue]
                this.$emit('getValue', value, this.name);
                this.visible = false;
                return
            }
            if (this.limit < this.dataListAllSelections.length) {
                this.$message.error(`你最多只能选择${this.limit}条数据`);
                return;
            }
            this.visible = false;
            console.log(this.dataListAllSelections,this.labelName)
            console.log(this.dataListAllSelections[0])//不行，对象
            // 跨页多选有问题的代码
            // this.name = this.dataListSelections
            //   .map((item) => {
            //     return item[this.labelName];
            //   })
            //   .join(",");
            // let value = this.dataListSelections
            //   .map((item) => {
            //     return item[this.labelValue];
            //   })
            //   .join(",");

            //跨页多选修改后的代码
            this.name = this.dataListAllSelections
                .map((item) => {
                    return item[this.labelName];
                })
                .join(',');
            let value = this.dataListAllSelections
                .map((item) => {
                    return item[this.labelValue];
                })
                .join(',');
            // if (this.ParentComponentName == 'RpsRepairListForm' && this.limit == 1) {
            //     let params = {
            //         id: this.dataListSelections[0].id,
            //         categoryId: this.dataListSelections[0].rpsCategory.id,
            //         rpsStationId: this.dataListSelections[0].rpsStation.id,
            //         equipmentInfo: this.dataListSelections[0]
            //     };
            //     this.$http.get(`${this.queryEntityUrl}?id=${params.id}`).then(({ data }) => {
            //         if (data.success) {
            //             params.officeId = data.rpsEquipment.office.id;
            //             params.officeName = data.rpsEquipment.office.name;
            //             this.$emit('getValue', params);
            //         }
            //     });
            // } else if (this.ParentComponentName == 'RpsStationForm') {
            //     this.$emit('getValue', JSON.parse(JSON.stringify(this.dataListSelections)));
            // } else {
            //     this.$emit('getValue', value, this.name);
            // }
            console.log(value,this.name)
            if (this.limit == 1) {
                this.$emit('getValue', value, this.name);
            }else{
                console.log("okokokokokokok")
                if(this.btn){
                    this.$emit('getValue', this.dataListSelections, this.name);
                }else{
                    this.$emit('getValue', value, this.name);
                }
            }
        },
        showSelectDialog() {
            this.visible = true;
            this.init();
        },
        changeVal(e) {
            if (this.ParentComponentName == 'goodsBuyChildForm') {
                this.$emit('getName', e.target.value);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

::v-deep .el-form-item {
    margin-bottom: 0;
}
</style>